export default "/images/support_banner.png?193ff75501c31fd6cf70b6a85f58b97f";